module.exports = __webpack_public_path__ + "img/nasr-web.632c0df2.jpeg";